<template>
    <section class="project-directory-page">
        <div class="project-directory-panel">
            <div class="project-directory-panel__header">
                <div class="project-directory-title">
                    <div class="project-directory-title__meta">
                        <span class="project-directory-title__eyebrow">{{ $t('Project Timeline') }}</span>
                        <span class="project-directory-count">
                            <strong>{{ ArrayList.length }}</strong>
                            <span>{{ $t('Contacts') }}</span>
                        </span>
                    </div>
                    <h1>{{ $t('Project Directory') }}</h1>
                </div>
                <div class="project-directory-header-actions">
                    <div class="project-directory-search">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <input type="text" autocomplete="false" :placeholder="$t('Search Contact Name')" v-model="searchUser" @input="searchFromDirectory" >
                    </div>
                    <button class="project-directory-add"
                    v-if="permission.indexOf(ModuleActionList.DIRECTORY_CREATE)>-1"
                    @click="OpenModal"
                    data-bs-toggle="modal" data-bs-target="#AddToDirectory"
                    ><i class="fa-solid fa-plus"></i> {{ $t('Add User to Directory') }}</button>
                </div>
            </div>
        </div>

        <div class="project-directory-empty" v-if="ArrayList.length===0">
            <i class="fa-solid fa-address-book"></i>
            <strong>{{ $t('Project Directory') }}</strong>
            <span>{{ $t('No data Found') }}</span>
        </div>

        <div class="project-directory-groups">
            <template v-for="(item,key) in  CompanyTypeList" :key="key">
                <div class="accordion project-directory-accordion" :id="'accordionGroupings'+key" v-if="ArrayList.findIndex(u=>u.companyType==item.id)!=-1"  >
                    <div class="accordion-item project-directory-group">
                        <h2 class="accordion-header">
                            <button class="accordion-button project-directory-group__toggle fw-bold" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapseOne' + key" aria-expanded="true" aria-controls="collapseOne">
                                <span class="project-directory-group__icon"><i class="fa-solid fa-users"></i></span>
                                <span class="project-directory-group__name">{{item.value}}</span>
                                <span class="project-directory-count project-directory-group__count">
                                    <strong>{{ CountByCompanyType(item.id) }}</strong>
                                    <span>{{ $t('Contacts') }}</span>
                                </span>
                            </button>
                        </h2>
                        <div :id="'collapseOne' + key"   class="accordion-collapse collapse show" aria-labelledby="headingOne" :data-bs-parent="'#accordionGroupings'+key">
                            <div class="accordion-body p-0">
                                <div class="project-directory-table-wrap">
                                    <table class="project-directory-table">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('Name') }}</th>
                                                <th>{{ $t('Role') }}</th>
                                                <th>{{ $t('Email') }}</th>
                                                <th>{{ $t('Contact') }}</th>
                                                <th>{{ $t('Actions') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template  v-for="(company,companyKey) in  GroupedCompany(ArrayList.filter(u=>u.companyType==item.id),item.id)" :key="companyKey">
                                                <tr v-if="item.id!=CompanyType.MMOSER" class="project-directory-company-row">
                                                    <td colspan="4" class="text-capitalize">
                                                        <i class="fa-solid fa-building-user"></i> {{company}}
                                                    </td>
                                                    <td>
                                                        <button class="project-directory-action project-directory-action--soft"
                                                        type="button"
                                                        v-if="permission.indexOf(ModuleActionList.DIRECTORY_EDIT)>-1"
                                                        data-bs-toggle="modal" data-bs-target="#EditCompanyModal" @click="OpenModalUpdateCompany(company)"
                                                        ><i class="fa-solid fa-pencil"></i> {{ $t('Edit') }} </button>
                                                    </td>
                                                </tr>
                                                <tr v-for="(child,childKey) in  CheckLoopRole(ArrayList,item.id,company)" :key="childKey">
                                                    <td class="project-directory-person text-capitalize">
                                                        <div class="project-directory-person__inner">
                                                            <img :src=" child.userId.photoUrl!='' && (typeof child.userId.photoUrl !=='undefined') ? child.userId.photoUrl : '/images/placeholder-user.png'"
                                                            @error="(e)=>{e.target.src = '/images/placeholder-user.png';}"
                                                            class="project-directory-avatar" >
                                                            <span>{{child.userId.fullname}}</span>
                                                        </div>
                                                    </td>
                                                    <td class="text-capitalize"> {{$t(child.roleIdProject)}} </td>
                                                    <td> <a :href="'mailto:' + child.userId.email"> {{child.userId.email}}</a> </td>
                                                    <td v-if="child.userId.contactNumber.length!=0" class="project-directory-contact">
                                                        <div class="project-directory-contact__inner">
                                                            <a :href="'tel:' + c" v-for="(c,i) in child.userId.contactNumber" :key="i">
                                                                {{c}}
                                                            </a >
                                                        </div>
                                                    </td>
                                                    <td v-else>
                                                        <span class="project-directory-muted"> {{ $t('No Contact number')}}</span>
                                                    </td>
                                                    <td>
                                                        <div class="project-directory-actions">
                                                            <button class="project-directory-action"
                                                            type="button"
                                                            v-if="permission.indexOf(ModuleActionList.DIRECTORY_EDIT)>-1"
                                                            @click="OpenUpdateModal(child._id)"
                                                            data-bs-toggle="modal" data-bs-target="#ModalUpdateUser"
                                                            ><i class="fa-solid fa-pencil"></i> {{ $t('Edit') }}</button>
                                                            <button  class="project-directory-action"
                                                            type="button"
                                                            @click="openPermission(child)"
                                                            data-bs-toggle="modal" data-bs-target="#PermissionModal"
                                                            v-if="permission.indexOf(ModuleActionList.DIRECTORY_PERMISSION)>-1&&item.id==CompanyType.MMOSER"
                                                            ><i class="fa-solid fa-key"></i>  {{ $t('Access') }} </button>
                                                            <!-- <a href="#" class="text-primary  pe-1" @click="changePermission(p._id)" title="Change Permission">
                                                                <i :class="p.isAdmin ? 'fa-solid fa-lock' : 'fas fa-lock-open'"></i>
                                                            </a> -->
                                                            <button  type="button" class="project-directory-action project-directory-action--danger"
                                                            @click="RemoveFromDirectory(child.userId._id)"
                                                            v-if="permission.indexOf(ModuleActionList.DIRECTORY_REMOVE)>-1"
                                                            >
                                                                <i class="fas fa-trash"></i>  {{ $t('Remove') }}
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </section>
    <CreateModalUser
    v-if="permission.indexOf(ModuleActionList.DIRECTORY_CREATE)>-1"
    idModal="AddToDirectory"
    :headerTitle="$t('Add User to Directory')"
    :SetList="SetList"
    :roleList="RoleMMoser"
    ref="ModalCreateUser"
    ></CreateModalUser>
    <Modal  idModal="ModalUpdateUser" :headerTitle="$t('Update User')" modalSize="modal-xl" >
        <fieldset class="directory-user-update-modal-form" :disabled="isLoadingData">
            <div class="form-group">
                <label>{{ $t('Company Type') }}</label>
                <input type="text" class="form-control" readonly :value="CompanyTypeList[updateUser.companyType - 1] ? CompanyTypeList[updateUser.companyType - 1].value : ''" />
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" v-if="CompanyType.MMOSER!=updateUser.companyType">
                        <label>{{ $t('Company Name') }} <span v-if="IsMissingRequired(updateUser.company)" class="directory-required-tag">({{ $t('required') }})</span></label>
                        <Select2
                        :filterQuery="SearchCompanies"
                        indexValue="_id"
                        labelName="companyName"
                        :placeHolder="$t('Search Company')"
                        ref="select2UsercompanyUpdate"
                        :iniLabel="updateUser.companyName"
                        :optionValue="updateUser.company"
                        v-model:optionValue="updateUser.company"
                        ></Select2>
                        <small class="text-warning" v-if="!updateUser.company&&SaveClicked">{{ $t('Required') }}</small>
                    </div>
                    <div class="form-group">
                        <label>{{ $t('First Name') }} <span v-if="IsMissingRequired(updateUser.firstName)" class="directory-required-tag">({{ $t('required') }})</span></label>
                        <input type="text" class="form-control" :placeholder="$t('First Name')" v-model="updateUser.firstName" />
                        <small class="text-warning" v-if="!updateUser.firstName&&SaveClicked">{{ $t('Required') }}</small>
                    </div>
                    <div class="form-group">
                        <label>{{ $t('Last Name') }} <span v-if="IsMissingRequired(updateUser.lastName)" class="directory-required-tag">({{ $t('required') }})</span></label>
                        <input type="text" class="form-control" :placeholder="$t('Last Name')" v-model="updateUser.lastName" />
                        <small class="text-warning" v-if="!updateUser.lastName&&SaveClicked">{{ $t('Required') }}</small>
                    </div>
                    <div class="form-group" v-if="CompanyType.MMOSER==updateUser.companyType">
                        <label>{{ $t('Role in Project') }} <span v-if="IsMissingRequired(updateUser.roleId)" class="directory-required-tag">({{ $t('required') }})</span></label>
                        <select class="form-select" v-model="updateUser.roleId">
                            <option value="">{{ $t('Please Select') }}</option>
                            <option v-for="(item, key) in RoleMMoser" :key="key" :value="item._id">{{ $t(item.roleName)}}</option>
                        </select>
                        <small class="text-warning" v-if="!updateUser.roleId&&SaveClicked">{{ $t('Required') }}</small>
                    </div>
                    <div class="form-group" v-else-if="CompanyType.CLIENT==updateUser.companyType" >
                        <label>{{ $t('Role in Project') }}</label>
                        <input type="text" class="form-control" readonly value="Client" />
                    </div>
                    <div class="form-group" v-else>
                        <label>{{ $t('Role in Project') }} <span v-if="IsMissingRequired(updateUser.roleProject)" class="directory-required-tag">({{ $t('required') }})</span></label>
                        <input type="text" class="form-control" :placeholder="$t('Role in Project')" v-model="updateUser.roleProject" />
                        <small class="text-warning" v-if="!updateUser.roleProject&&SaveClicked">{{ $t('Required') }}</small>
                    </div>

                    <div class="form-group">
                        <label>{{ $t('Job Description') }} <span v-if="IsMissingRequired(updateUser.jobDescription)" class="directory-required-tag">({{ $t('required') }})</span></label>
                        <input type="text" class="form-control" :placeholder="$t('Job Description')" v-model="updateUser.jobDescription" />
                        <small class="text-warning" v-if="!updateUser.jobDescription&&SaveClicked">{{ $t('Required') }}</small>
                    </div>

                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ $t('Email') }} <span v-if="IsMissingRequired(updateUser.email)" class="directory-required-tag">({{ $t('required') }})</span></label>
                        <input type="text" class="form-control" placeholder="sample@gmail.com" v-model="updateUser.email" />
                        <small class="text-warning" v-if="SaveClicked && (!updateUser.email || !IsValidEmail(updateUser.email))">{{ $t('Required') }}</small>
                    </div>
                    <div class="form-group">
                        <label>{{ $t('Photo Url') }}</label>
                        <input type="text" class="form-control" placeholder="https://url" v-model="updateUser.photoUrl" />
                    </div>
                    <div class="form-group">
                        <label>{{ $t('Address') }}</label>
                        <textarea class="form-control" v-model="updateUser.address" :placeholder="$t('Address')"></textarea>
                    </div>
                    <div class="form-group" v-for="(item, key) in updatedContacts" :key="key">
                        <div class="d-flex justify-content-between">
                            <label>{{ $t('Contact Number') }}</label>
                            <small @click="RemoveContact(key)" class="directory-contact-remove" role="button"><i class="fa-solid fa-minus"></i> {{ $t('Remove') }}</small>
                        </div>
                        <input type="tel" inputmode="tel" class="form-control" placeholder="+6312345678910" v-model="item.value" @input="FilterContactNumber(item, $event)" />
                    </div>
                    <div>
                        <small @click="AddNewLineContact" class="directory-contact-add" role="button"><i class="fa-solid fa-plus"></i> {{ $t('Add Contact Number') }}</small>
                    </div>

                </div>
            </div>
        </fieldset>
        <template v-slot:actions>
            <button type="button" ref="closeDirModalUpdate" class="btn btn-outline-danger" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <div v-if="!isLoadingData">
                <button type="button" class="directory-update-save" @click="UpdateUserRun" ><i class="fas fa-save"></i> {{ $t('Save Changes') }}</button>
            </div>
        </template>
    </Modal>
    <Modal idModal="EditCompanyModal" :headerTitle="$t('Edit Company')" modalSize="modal-xl">
        <div class="directory-company-modal-form">
        <div class="form-group">
            <label>{{ $t('Company Name') }} <span v-if="!updateCompanyData.companyName" class="directory-required-tag">({{ $t('required') }})</span></label>
            <input type="text" class="form-control" :placeholder="$t('Company Name')" v-model="updateCompanyData.companyName" />
            <small class="text-warning" v-if="isUpdateCompanyClicked&&!updateCompanyData.companyName">{{$t('Required')}}</small>
        </div>
        <div class="form-group">
            <label>{{ $t('Company Address') }} <span v-if="!updateCompanyData.address" class="directory-required-tag">({{ $t('required') }})</span></label>
            <textarea class="form-control" v-model="updateCompanyData.address" :placeholder="$t('Company Address')"></textarea>
            <small class="text-warning" v-if="isUpdateCompanyClicked&&!updateCompanyData.address"> {{$t('Required')}} </small>
        </div>
        <div class="form-group" v-if="updateCompanyData.companyType==CompanyType.VENDOR">
            <label>{{ $t('Main Trade') }}</label>
            <select class="form-select" v-model="updateCompanyData.mainTrade">
                <option value="">{{ $t('Please Select') }}</option>
                <template v-for="(item, key) in TradeTypeList" :key="key">
                    <option :value="item._id">{{item.companyTypeName}}</option>
                </template>
            </select>
        </div>
        <div class="form-group">
            <label>{{ $t('Company Email') }}</label>
            <input type="text" class="form-control" :placeholder="$t('Company Email')" v-model="updateCompanyData.email" />
        </div>
        <div class="form-group">
            <label >{{ $t('Company Phone No') }}</label>
            <input type="text" class="form-control" :placeholder="$t('Company Phone No')" v-model="updateCompanyData.phone" />
        </div>
        <div class="form-group">
            <label >{{ $t('Fax') }}</label>
            <input type="text" class="form-control" :placeholder="$t('Fax')" v-model="updateCompanyData.fax" />
        </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeUpdateModalCompany" class="btn btn-outline-danger" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <button class="directory-company-save" :disabled="isSavingCompany" @click="UpdateCompany" ><i class="fa-solid fa-floppy-disk"></i> {{ $t('Save Changes') }}</button>
        </template>
    </Modal>
</template>
<script src="@/assets/projectJs/components/DirectoryInfo.js" />

<style scoped>
.project-directory-page {
    --directory-accent: #298969;
    --directory-accent-dark: #166b51;
    --directory-accent-soft: #e8f7ef;
    --directory-border: #d9e2dd;
    --directory-text: #1e1b16;
    --directory-muted: #777777;
    --directory-surface: #ffffff;
    --directory-row: #fbfcfb;
    --directory-row-alt: #f3f6f4;
    color: var(--directory-text);
}

.project-directory-panel {
    margin-bottom: 1.25rem;
    border: 1px solid var(--directory-border);
    border-radius: 6px;
    background: var(--directory-surface);
    box-shadow: 0 0.8rem 2rem rgba(30, 27, 22, 0.08);
    overflow: hidden;
}

.project-directory-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.25rem;
    padding: 1.15rem 1.35rem;
}

.project-directory-title {
    min-width: 12rem;
}

.project-directory-title__meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.25rem;
}

.project-directory-title__eyebrow {
    display: block;
    color: var(--directory-muted);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0;
}

.project-directory-title h1 {
    margin: 0;
    color: var(--directory-text);
    font-size: 1.35rem;
    font-weight: 800;
    line-height: 1.2;
}

.project-directory-header-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
    flex: 1;
    min-width: 0;
}

.project-directory-search {
    display: flex;
    width: min(34rem, 42vw);
    min-width: 26rem;
    min-height: 2.75rem;
    align-items: center;
    border: 1px solid var(--directory-border);
    border-radius: 6px;
    background: #ffffff;
    box-shadow: 0 0.35rem 1rem rgba(30, 27, 22, 0.06);
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.project-directory-search:focus-within {
    border-color: var(--directory-accent);
    box-shadow: 0 0 0 3px rgba(41, 137, 105, 0.14), 0 0.35rem 1rem rgba(30, 27, 22, 0.06);
}

.project-directory-search i {
    width: 2.8rem;
    color: var(--directory-muted);
    text-align: center;
}

.project-directory-search input {
    min-width: 0;
    flex: 1;
    border: 0;
    padding: 0.72rem 0.75rem 0.72rem 0;
    color: var(--directory-text);
    background: transparent;
    outline: 0;
}

.project-directory-search input::placeholder {
    color: #7e8b86;
}

.project-directory-add {
    display: inline-flex;
    min-height: 2.75rem;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;
    border: 1px solid var(--directory-accent);
    border-radius: 4px;
    padding: 0.65rem 1.25rem;
    min-width: 13.25rem;
    color: #ffffff;
    background: var(--directory-accent);
    font-size: 0.88rem;
    font-weight: 800;
    line-height: 1;
    white-space: nowrap;
}

.project-directory-add:hover {
    background: var(--directory-accent-dark);
    border-color: var(--directory-accent-dark);
}

.project-directory-count {
    display: inline-flex;
    min-height: 1.45rem;
    align-items: center;
    gap: 0.3rem;
    border: 1px solid #cfe4da;
    border-radius: 999px;
    padding: 0.2rem 0.55rem;
    color: var(--directory-accent-dark);
    background: var(--directory-accent-soft);
    font-size: 0.72rem;
    font-weight: 800;
    line-height: 1;
}

.project-directory-count strong {
    font-size: inherit;
}

.project-directory-empty {
    display: flex;
    min-height: 10rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    border: 1px solid var(--directory-border);
    border-radius: 6px;
    color: var(--directory-muted);
    background: #ffffff;
    box-shadow: 0 0.8rem 2rem rgba(30, 27, 22, 0.07);
}

.project-directory-empty i,
.project-directory-empty strong {
    color: var(--directory-accent);
}

.project-directory-groups {
    display: grid;
    align-items: start;
    gap: 0.9rem;
}

.project-directory-accordion {
    border-radius: 6px;
    margin: 0;
}

.project-directory-group {
    border: 1px solid var(--directory-border);
    border-radius: 6px;
    background: #ffffff;
    box-shadow: 0 0.8rem 2rem rgba(30, 27, 22, 0.08);
    overflow: hidden;
}

.project-directory-group__toggle,
.project-directory-group__toggle:not(.collapsed) {
    min-height: 4rem;
    gap: 0.75rem;
    border: 0;
    padding: 1rem 1.25rem;
    color: var(--directory-text);
    background: #ffffff;
    box-shadow: none;
}

.project-directory-group__toggle:hover,
.project-directory-group__toggle:focus {
    color: var(--directory-accent-dark);
    background: #f7fbf9;
    box-shadow: none;
}

.project-directory-group__icon {
    display: inline-flex;
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: var(--directory-accent);
    background: var(--directory-accent-soft);
}

.project-directory-group__name {
    font-size: 1.05rem;
    font-weight: 800;
}

.project-directory-group__count {
    margin-left: 0.35rem;
    font-size: 0.72rem;
}

.project-directory-table-wrap {
    overflow-x: auto;
    border-top: 1px solid var(--directory-border);
}

.project-directory-table {
    width: 100%;
    min-width: 58rem;
    border-collapse: collapse;
    color: var(--directory-text);
    background: #ffffff;
    font-size: 0.9rem;
}

.project-directory-table th {
    padding: 0.85rem 1rem;
    border-bottom: 1px solid var(--directory-border);
    color: var(--directory-text);
    background: #f7f4f0;
    font-size: 0.82rem;
    font-weight: 800;
    text-align: left;
}

.project-directory-table td {
    padding: 0.85rem 1rem;
    border-bottom: 1px solid var(--directory-border);
    vertical-align: middle;
}

.project-directory-table tbody tr:nth-child(even):not(.project-directory-company-row) td {
    background: var(--directory-row);
}

.project-directory-table tbody tr:not(.project-directory-company-row):hover td {
    background: #f4fbf8;
}

.project-directory-company-row td {
    color: var(--directory-accent-dark);
    background: var(--directory-accent-soft);
    font-weight: 800;
}

.project-directory-company-row i {
    margin-right: 0.45rem;
    color: var(--directory-accent);
}

.project-directory-person {
    font-weight: 700;
}

.project-directory-person__inner {
    display: inline-flex;
    align-items: center;
    gap: 0.65rem;
}

.project-directory-avatar {
    width: 2.15rem;
    height: 2.15rem;
    flex: 0 0 2.15rem;
    border: 2px solid #ffffff;
    border-radius: 50%;
    object-fit: cover;
    box-shadow: 0 0 0 1px var(--directory-border);
}

.project-directory-contact__inner {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
}

.project-directory-contact__inner a {
    display: inline-flex;
    min-height: 1.6rem;
    align-items: center;
    border-radius: 999px;
    padding: 0.2rem 0.65rem;
    color: #0b6697;
    background: #e7f4fb;
    font-weight: 700;
    text-decoration: none;
}

.project-directory-muted {
    color: var(--directory-muted);
}

.project-directory-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.project-directory-action {
    display: inline-flex;
    min-height: 1.9rem;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    border: 1px solid #cfe4da;
    border-radius: 999px;
    padding: 0.32rem 0.75rem;
    color: var(--directory-accent-dark);
    background: #ffffff;
    font-size: 0.78rem;
    font-weight: 800;
    line-height: 1;
}

.project-directory-action:hover {
    color: #ffffff;
    background: var(--directory-accent);
    border-color: var(--directory-accent);
}

.project-directory-action--soft {
    background: var(--directory-accent-soft);
}

.project-directory-action--danger {
    color: #ce2c2c;
    border-color: #f1c7c7;
    background: #fff7f7;
}

.project-directory-action--danger:hover {
    color: #ffffff;
    border-color: #ce2c2c;
    background: #ce2c2c;
}

.project-directory-table a {
    color: #007bff;
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
}

.directory-company-modal-form .form-group,
.directory-user-update-modal-form .form-group {
    margin-bottom: 1rem;
}

.directory-company-modal-form label,
.directory-user-update-modal-form label {
    display: flex;
    min-height: 1rem;
    align-items: baseline;
    gap: 0.25rem;
    margin-bottom: 0.35rem;
    color: #27241f;
    font-size: 0.84rem;
    font-weight: 800;
}

.directory-required-tag {
    color: #ff0000;
    font-size: 0.82em;
    font-weight: 800;
}

.directory-company-modal-form .form-control,
.directory-company-modal-form .form-select,
.directory-user-update-modal-form .form-control,
.directory-user-update-modal-form .form-select,
.directory-user-update-modal-form :deep(.select2-design) {
    min-height: 2.55rem;
    border: 1px solid #d7e0da;
    border-radius: 5px;
    color: #1f241f;
    background-color: #ffffff;
    box-shadow: none;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.directory-company-modal-form .form-control:focus,
.directory-company-modal-form .form-select:focus,
.directory-user-update-modal-form .form-control:focus,
.directory-user-update-modal-form .form-select:focus,
.directory-user-update-modal-form :deep(.select2-design:focus) {
    border-color: var(--directory-accent);
    box-shadow: 0 0 0 3px rgba(41, 137, 105, 0.14);
}

.directory-company-modal-form .form-control::placeholder,
.directory-user-update-modal-form .form-control::placeholder,
.directory-user-update-modal-form :deep(.select2-design::placeholder) {
    color: #7d8983;
}

.directory-company-modal-form textarea.form-control,
.directory-user-update-modal-form textarea.form-control {
    min-height: 5.5rem;
    resize: vertical;
}

.directory-company-modal-form .text-warning,
.directory-user-update-modal-form .text-warning {
    font-weight: 700;
}

.directory-user-update-modal-form .row {
    --bs-gutter-x: 1.35rem;
}

.directory-contact-add {
    color: #173d78;
    font-weight: 700;
}

.directory-contact-add:hover,
.directory-contact-add:focus {
    color: #102b55;
}

.directory-contact-remove {
    color: #d92525;
    font-weight: 800;
}

.directory-contact-remove:hover,
.directory-contact-remove:focus {
    color: #b61717;
}

:global(#EditCompanyModal .modal-dialog) {
    max-width: min(58rem, calc(100vw - 3rem));
}

:global(#ModalUpdateUser .modal-dialog) {
    max-width: min(64rem, calc(100vw - 3rem));
}

:global(#EditCompanyModal .modal-content),
:global(#ModalUpdateUser .modal-content) {
    border: 0;
    border-radius: 6px;
    box-shadow: 0 1.2rem 3rem rgba(30, 27, 22, 0.26);
    overflow: visible;
}

:global(#EditCompanyModal .modal-header),
:global(#ModalUpdateUser .modal-header) {
    align-items: center;
    padding: 1.15rem 1.35rem;
    border-bottom: 1px solid #dde5df;
    background: #ffffff;
}

:global(#EditCompanyModal .modal-title),
:global(#ModalUpdateUser .modal-title) {
    color: #1e1b16;
    font-size: 1.28rem;
    font-weight: 800;
}

:global(#EditCompanyModal .btn-close),
:global(#ModalUpdateUser .btn-close) {
    opacity: 0.55;
}

:global(#EditCompanyModal .btn-close:hover),
:global(#ModalUpdateUser .btn-close:hover) {
    opacity: 0.9;
}

:global(#EditCompanyModal .modal-body),
:global(#ModalUpdateUser .modal-body) {
    padding: 1.15rem 1.35rem;
    background: #fbfcfb;
}

:global(#EditCompanyModal .modal-footer),
:global(#ModalUpdateUser .modal-footer) {
    padding: 1rem 1.35rem;
    border-top: 1px solid #dde5df;
    background: #ffffff;
}

:global(#EditCompanyModal .modal-footer .btn),
:global(#ModalUpdateUser .modal-footer .btn) {
    min-width: 8.75rem;
    min-height: 2.45rem;
    border-radius: 0;
    font-size: 0.86rem;
    font-weight: 800;
}

:global(#EditCompanyModal .modal-footer .btn-outline-danger),
:global(#ModalUpdateUser .modal-footer .btn-outline-danger) {
    border-color: #dddddd;
    color: #1f241f;
    background: #dddddd;
}

:global(#EditCompanyModal .modal-footer .btn-outline-danger:hover),
:global(#ModalUpdateUser .modal-footer .btn-outline-danger:hover) {
    border-color: #cfcfcf;
    background: #cfcfcf;
}

.directory-company-save,
.directory-update-save {
    display: inline-flex;
    min-width: 9.5rem;
    min-height: 2.45rem;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;
    border: 1px solid #ff6126;
    border-radius: 4px;
    padding: 0.65rem 1.15rem;
    color: #ffffff;
    background: #ff6126;
    font-size: 0.86rem;
    font-weight: 800;
    line-height: 1;
}

.directory-company-save:hover,
.directory-company-save:focus,
.directory-update-save:hover,
.directory-update-save:focus {
    border-color: #ed541d;
    background: #ed541d;
}

.directory-company-save:disabled,
.directory-update-save:disabled {
    cursor: not-allowed;
    opacity: 0.65;
}

:global(.directory-status-popup) {
    width: min(28rem, calc(100vw - 2rem));
    border: 1px solid #d9e2dd;
    border-radius: 6px;
    padding: 2rem 2rem 1.65rem;
    background: #ffffff;
    box-shadow: 0 1.2rem 3rem rgba(30, 27, 22, 0.26);
    font-family: "Albert Sans", Arial, sans-serif;
}

:global(.directory-status-title) {
    padding: 0;
    color: #1e1b16;
    font-size: 1.28rem;
    font-weight: 800;
    line-height: 1.3;
}

:global(.directory-status-message) {
    margin: 0.7rem 0 0;
    padding: 0;
    color: #777777;
    font-size: 0.9rem;
    line-height: 1.55;
}

:global(.directory-status-popup .directory-status-loader) {
    width: 2.6rem;
    height: 2.6rem;
    margin: 1.4rem auto 0;
    border-width: 0.22rem;
    border-color: #298969 transparent #298969 transparent;
}

:global(.directory-status-icon.swal2-success) {
    border-color: #298969;
    color: #298969;
}

:global(.directory-status-icon.swal2-success [class^="swal2-success-line"]) {
    background-color: #298969;
}

:global(.directory-status-icon.swal2-success .swal2-success-ring) {
    border-color: rgba(41, 137, 105, 0.28);
}

:global(.directory-status-popup .swal2-actions) {
    margin-top: 1.4rem;
}

:global(.directory-status-confirm) {
    display: inline-flex;
    min-width: 9.5rem;
    min-height: 2.45rem;
    align-items: center;
    justify-content: center;
    border: 1px solid #298969;
    border-radius: 4px;
    padding: 0.65rem 1.15rem;
    color: #ffffff;
    background: #298969;
    font-size: 0.86rem;
    font-weight: 800;
    line-height: 1;
}

:global(.directory-status-confirm:hover),
:global(.directory-status-confirm:focus) {
    border-color: #166b51;
    outline: 0;
    color: #ffffff;
    background: #166b51;
    box-shadow: none;
}

:global(.deluxe-layout.dark) .project-directory-panel,
:global(.deluxe-layout.dark) .project-directory-group,
:global(.deluxe-layout.dark) .project-directory-empty,
:global(.deluxe-layout.dark) .project-directory-table,
:global(.deluxe-layout.dark) .project-directory-group__toggle,
:global(.deluxe-layout.dark) .project-directory-group__toggle:not(.collapsed) {
    color: var(--directory-text);
    background: #ffffff;
}

:global(.deluxe-layout.dark) .project-directory-title h1,
:global(.deluxe-layout.dark) .project-directory-group__toggle,
:global(.deluxe-layout.dark) .project-directory-table th,
:global(.deluxe-layout.dark) .project-directory-table td {
    color: var(--directory-text);
}

:global(.deluxe-layout.dark) .project-directory-search {
    background: #ffffff;
}

:global(.deluxe-layout.dark) .project-directory-search input {
    color: var(--directory-text);
}

@media (max-width: 991.98px) {
    .project-directory-panel__header,
    .project-directory-header-actions {
        align-items: stretch;
        flex-direction: column;
    }

    .project-directory-add,
    .project-directory-search {
        width: 100%;
        min-width: 0;
    }

    .project-directory-count {
        align-self: flex-start;
    }
}
</style>
